export default {
  parameters: {
    segment: 4,
    date_start: 4,
    date_end: 7,
    countryCode: 'RU',
    success_page: 'latam_more_information',
    only_countries1: 'by',
    only_countries2: 'tr',
    teenagers: 'false',
  },
  downtimeUrl: "https://tr2.kodland.tech",
  new_social_proof: false,
  ageRules: {
    min: 5,
    max: 7,
  },
  startPage: {
    image: "/welcome/quiz_turkey_teenagers_pk.png",
    imageMobile: "/welcome/quiz_turkey_teenagers_mobile.png",
    title: "5 soruyu yanıtlayın ve ÜCRETSİZ web seminerine kaydolun ",
    subtitle: "Sınıfta oyunlar tasarlayacağız ve birçok arkadaşla tanışacaksınız!",
    button: "Kaydolun",
  },
  quizRotateBySteps: {
    1: {
      question: "Okulda en sevdiğiniz ders nedir? ",
      subtitle:
        "<strong>Существуют</strong> две основные трактовки понятия «текст»: имманентная (расширенная, философски нагруженная) и репрезентативная (более частная). Имманентный подход подразумевает отношение к тексту как к автономной реальности, нацеленность на выявление его внутренней структуры. Репрезентативный — рассмотрение текста как особой формы представления информации о внешней тексту действительности.",
      image: {
        image_main: "/welcome/test_image.png",
        imageMobile: "/welcome/quiz_turkey_teenagers_mobile.png",
        url_video: "https://www.youtube.com/embed/5lCRsLjMeso",
        isMainImage: false,
        isVideo: true,
      },
      answers: [
        "🔬 Fen bilimleri",
        {
          answer: "🎨 Sanat ve tasarım",
          img: "",
          isImage: false,
          answerIsNull: false,
          event_name: "parent_test",
          distribution_tag_question: [6],
          event_source: "yandex/google",
        },
        {
          answer: "💻 Bilgisayar bilimi",
          img: "/welcome/happy_cat_2.jpeg",
          isImage: true,
          answerIsNull: false,
          event_name: "parent_google",
          event_source: "google",
        },
        {
          answer: "📙 Tarih, Edebiyat",
          img: "",
          isImage: false,
          answerIsNull: false,
          event_name: "parent",
          event_source: "yandex",
        },
        {
          answer: "📐 Matematik",
          img: "",
          isImage: false,
          answerIsNull: false,
          event_name: "parent",
          event_source: "yandex",
        },
        {
          answer: "💬 Yabancı diller",
          img: "/welcome/happy_cat_2.jpeg",
          isImage: true,
          answerIsNull: false,
          event_name: "parent",
          event_source: "yandex",
        },
        {
          answer: "🤩 Tüm dersler",
          img: "",
          isImage: false,
          answerIsNull: false,
          event_name: "parent",
          event_source: "yandex",
        },
        {
          answer: "🤔 Emin değilim",
          img: "",
          isImage: false,
          answerIsNull: false,
          event_name: "parent",
          event_source: "yandex",
        },
      ],
    },

    2: {
      stopNew: true,
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      subtitle:
        "<i>Мак</i> встречается в умеренной, субтропической и реже в холодных зонах. Большинство маков растёт в засушливых местах — степях, полупустынях, пустынях, сухих каменистых склонах гор.",
      image: {
        image_main: "/welcome/test_image.png",
        imageMobile: "",
        isMainImage: true,
        isVideo: false,
      },
      answers: [
        {
          answer: "💻 Evet",
          img: "/welcome/happy_cat.jpg",
          isImage: true,
          event_name: "parent",
          event_source: "yandex",
        },
        {
          answer: "😐 Hayır",
          stopAnswer: true,
        },
      ],
      stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Test 1",
      },
    },
    3: {
      stopNew: true,
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      image: {
        image_main: "/welcome/test_image.png",
        imageMobile: "",
        isMainImage: true,
        isVideo: false,
      },
      answers: [
        { answer: "💻 Evet", img: "/welcome/happy_cat.jpg", isImage: true },
        {
          answer: "😐 Hayır",
          stopAnswer: true,
        },
      ],
      stopPage: {
        image: "/welcome/happy_cat.jpg",
        title: "Test 2",
      },
    },
    4: {
      title: "ÜCRETSİZ web semineri için ne zaman uygunsunuz?",
      type: "timeslot",
      subtitle:
        "Yerinizi ayırtmak için sadece birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳 ",
      button: "Rezervasyon için tıklayın 🎁",
    },
    5: {
      title: "Yaşınız?",
      type: "age",
      subtitle: "Yaşınıza göre en eğlenceli parkuru seçeceğiz",
      button: "İleri 🚀",
    },
    6: {
      title: "İsminizi girin",
      type: "parent_name",
      subtitle: "Bizim adımız Kodland, sizinki ne?👋",
      button: "İleri 🚀",
    },
    7: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
      button: "İleri 🚀",
    },
    8: {
      question: "İlk etapta ne kodlamak istiyorsunuz?",
      answers: [
        "Kendi oyunlarımı yapmak",
        "Telefon uygulamaları yazmak",
        "Web siteleri oluşturmak",
        "Henüz bilmiyorum",
      ],
    },
    9: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle:
        "Web semineri hakkında hatırlatma yapmak için sizinle iletişime geçmek için kullanacağız 📞",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "Ebeveyn adı",
      type: "child_name",
      subtitle: "Ebeveyn adını girin",
      button: "Neredeyse bitti 🔥",
    },
  },
};
